import Client from '@/app/repository/axios-client';

const resource = '/report/reports';

export default {
  getInactiveSubaccountForGrid(payload) {
    return Client.get(`${resource}/inactive-subaccount/grid` + payload);
  },

  getInactiveSubaccountForExcel(payload) {
    return Client.get(`${resource}/inactive-subaccount/excel` + payload,
      {
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      });
  },
};
